const en: Record<string, string> = {
    // Header
    features: "Features",
    compare: "Compare",
    bonus: "Bonus",
    faq: "FAQ",
    getRakeback: "Get 50% Rakeback",
    
    // Hero
    updatedDate: "Updated January 2026",
    heroTitle1: "Duel Casino",
    heroTitle2: "Bonus Code 2026",
    heroDesc: "Use code",
    heroDescEnd: "for 50% instant rakeback on Duel.com. No KYC, instant crypto withdrawals, provably fair games.",
    codeLabel: "Code",
    claimRakeback: "Claim 50% Rakeback",
    rakeback: "Rakeback",
    cryptos: "Cryptos",
    withdrawals: "Withdrawals",
    instant: "Instant",
    kyc: "KYC",
    none: "None",
    welcomeBonus: "Welcome Bonus",
    rakebackValue: "50% Rakeback",
    onEveryBet: "On every bet, instantly credited",
    active: "Exclusive",
    cryptosCount: "16+ Cryptos",
    cryptosList: "BTC, ETH, SOL, USDT...",
    instantPayouts: "Instant Payouts",
    noDelays: "24/7, no delays",
    noKyc: "No KYC",
    playAnonymously: "Players enjoying Duel.com",
    totalWagered: "+$7,000,000,000",
    totalWageredDesc: "Total volume",
    playerCount: "+100,000",
    provablyFair: "Provably Fair",
    verifiedOutcomes: "Verified outcomes",
    licensed: "Licensed",
    licenseAuthority: "Anjouan Gaming License",
    licenseNo: "ALSI-202411026-FI1",
    
    // Features
    platformOverview: "Platform Overview",
    whyDuel: "Why Duel Casino?",
    featuresDesc: "A crypto-native casino with 50% rakeback, instant withdrawals, and no identity verification.",
    featuresIntro: "Duel Casino was built by players, for players. Created by the team behind CSGOEmpire, it offers provably fair games with 0% house edge on Originals, instant crypto payouts, and up to 50% rakeback on every bet. No KYC required — just fast, transparent, and fair crypto gambling.",
    payments: "Payments",
    games: "Games",
    security: "Security",
    bitcoin: "Bitcoin (BTC)",
    ethereum: "Ethereum (ETH)",
    solana: "Solana (SOL)",
    tether: "Tether (USDT)",
    usdCoin: "USD Coin (USDC)",
    litecoin: "Litecoin (LTC)",
    moreCryptos: "+10 more cryptos",
    originalGames: "Original Games",
    slots: "Slots",
    liveCasino: "Live Casino",
    sportsBetting: "Sports Betting",
    zeroEdgeGames: "Zero Edge Games",
    noKycRequired: "No KYC Required",
    provablyFairFeature: "Provably Fair",
    instantWithdrawals: "Instant Withdrawals",
    anonymousPlay: "Anonymous Play",
    support247: "24/7 Support",
    
    // Bonus Card
    howItWorks: "How It Works",
    claimIn3Steps: "Claim in 3 Steps",
    step1Title: "Sign Up",
    step1Desc: "Create account via our link",
    step2Title: "Enter Code",
    step2Desc: "Use bonus code COM",
    step3Title: "Get Rakeback",
    step3Desc: "50% back on every bet",
    startNow: "Start Now — Get 50% Rakeback",
    whatYouGet: "What You Get",
    bonusBenefits: "Bonus Benefits",
    benefit1: "50% instant rakeback on all games",
    benefit2: "No deposit required to activate",
    benefit3: "Works with all 16+ cryptocurrencies",
    benefit4: "No wagering requirements on rakeback",
    benefit5: "Instant withdrawals, 24/7",
    benefit6: "No KYC verification needed",
    bonusCode: "Bonus Code",
    value: "Value",
    
    // FAQ
    faqLabel: "FAQ",
    commonQuestions: "Common Questions",
    faq1Q: "What is the Duel Casino bonus code?",
    faq1A: "The bonus code is COM. Enter it during registration or use any link on this site to automatically apply the 50% instant rakeback bonus.",
    faq2Q: "What does 50% rakeback mean?",
    faq2A: "You receive 50% of the house edge back instantly on every bet. This significantly increases your overall returns compared to playing without rakeback.",
    faq3Q: "Which cryptocurrencies are supported?",
    faq3A: "Duel Casino supports 16+ cryptocurrencies including Bitcoin, Ethereum, Solana, Tether (USDT), USDC, Litecoin, Dogecoin, XRP, and more.",
    faq4Q: "Is KYC verification required?",
    faq4A: "No. Duel Casino does not require identity verification. You can play anonymously — even email is optional during registration.",
    faq5Q: "How fast are withdrawals?",
    faq5A: "Withdrawals are instant and available 24/7. There's no waiting period or manual review — crypto is sent to your wallet immediately.",
    faq6Q: "Are the games provably fair?",
    faq6A: "Yes. All games use provably fair technology. You can cryptographically verify the fairness of every game outcome.",
    faq7Q: "Is Duel Casino legal to use?",
    faq7A: "Duel Casino operates under an Anjouan gaming license (ALSI-202411026-FI1). However, online gambling laws vary by jurisdiction. Players are responsible for ensuring they comply with local regulations.",
    faq8Q: "What is provably fair gaming?",
    faq8A: "Provably fair is a cryptographic technology that lets you verify game outcomes are genuinely random. Before each game, a hash is generated. After the game, you can check this hash to confirm results weren't manipulated.",
    faq9Q: "How does rakeback compare to deposit bonuses?",
    faq9A: "Rakeback is superior because it has no wagering requirements. Traditional deposit bonuses require 30-50x wagering before withdrawal. Rakeback earnings are instantly withdrawable with no conditions.",
    faq10Q: "Can I play Duel Casino on mobile?",
    faq10A: "Yes. Duel Casino is fully optimized for mobile browsers. No app download required — simply visit duel.com on any smartphone or tablet.",
    faq11Q: "What are the minimum and maximum bet limits?",
    faq11A: "Bet limits vary by game. Most games allow bets from $0.10 up to $10,000+. Original games typically have the highest maximum bets available.",
    faq12Q: "How do I verify game outcomes?",
    faq12A: "Each game provides a client seed and server seed hash. After the game, reveal the server seed and use any SHA-256 calculator to verify the outcome matches. Duel provides verification tools directly.",
    faq13Q: "Which games have the best odds?",
    faq13A: "Duel Originals offer the best odds with 0% house edge on games like Blackjack, Crash, and Dice. Combined with 50% rakeback, you're actually playing with positive expected value.",
    faq14Q: "Is my cryptocurrency safe at Duel Casino?",
    faq14A: "Duel Casino uses industry-standard security including cold storage for funds, 2FA authentication options, and encrypted connections. Instant withdrawals mean you don't need to keep large balances on-site.",
    faq15Q: "Can I use multiple cryptocurrencies?",
    faq15A: "Yes. You can deposit and withdraw using any of 16+ supported cryptocurrencies including BTC, ETH, SOL, USDT, USDC, LTC, and more. You can even switch between currencies.",
    
    // Calculator
    calcLabel: "Calculate",
    calcTitle: "Rakeback Calculator",
    calcDesc: "See how much you save with 50% rakeback. Enter your betting details below.",
    calcBetAmount: "Bet Amount ($)",
    calcNumBets: "Number of Bets",
    calcHouseEdge: "House Edge (%)",
    calcTotalWagered: "Total Wagered",
    calcWithoutRakeback: "Expected Loss (No Rakeback)",
    calcWithRakeback: "Rakeback Earned",
    calcEffectiveEdge: "Effective House Edge",
    calcYouSave: "You Save 50%",
    calcSummary: "With code",
    calcSummaryEnd: "you get half of every house edge returned instantly. No wagering requirements.",
    
    // Author
    authorReviewedBy: "Reviewed by",
    authorExpert: "Crypto Gaming Expert",
    authorUpdated: "Last updated",
    
    // CTA
    readyToStart: "Ready to start?",
    ctaDesc: "Use code",
    ctaDescEnd: "for 50% instant rakeback on Duel Casino.",
    claim50Rakeback: "Claim 50% Rakeback",
    
    // Footer
    footerDesc: "Independent guide to Duel Casino. Transparent reviews, verified bonus codes, and expert insights for crypto gaming.",
    contentVerified: "Content verified: January 2026",
    navigation: "Navigation",
    legal: "Legal",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    responsibleGaming: "Responsible Gaming",
    disclaimer: "Disclaimer:",
    disclaimerText: "Duelbonus.co is an independent affiliate site. We may receive compensation for referrals. Gambling involves risk — only gamble with money you can afford to lose. 18+ only. Please gamble responsibly.",
    gambleResponsibly: "18+ | Gamble Responsibly",
    
    // SEO Content
    learnMore: "Learn More",
    everythingAbout: "Everything About Duel Casino",
    seoTitle1: "Duel Casino Bonus Code: Your Complete Guide to 50% Rakeback",
    seoIntro1: "Looking for the best Duel Casino bonus code in 2026? The exclusive code COM unlocks an incredible 50% instant rakeback on every bet you place. Unlike traditional welcome bonuses that come with complicated wagering requirements, the Duel Casino bonus provides real, immediate value that gets credited to your account instantly.",
    seoH3_1: "How the Duel Casino Bonus Code Works",
    seoP1_1: "The Duel Casino bonus code system is refreshingly simple. When you register using code COM, you automatically qualify for 50% rakeback on all your gaming activity. This means that for every bet you place, you receive half of the house edge back instantly. Whether you're playing slots, original games, or trying your luck at the live casino, your rakeback accumulates in real-time.",
    seoP1_2: "The mathematics behind rakeback are straightforward. If a game has a 4% house edge and you wager $100, the expected house profit would be $4. With 50% rakeback, you receive $2 back immediately, effectively cutting the house edge in half to just 2%. Over thousands of bets, this difference compounds significantly.",
    seoH3_2: "Why 50% Rakeback Beats Traditional Casino Bonuses",
    seoP2_1: "Traditional casino bonus structures often require players to wager their bonus amount 30x, 40x, or even 50x before withdrawing. The rakeback model eliminates this frustration entirely. There are no wagering requirements on your rakeback earnings — what you earn is yours to withdraw immediately.",
    seoP2_2: "Consider a typical $100 deposit bonus with 40x wagering requirements. You would need to wager $4,000 before withdrawing anything. With rakeback, every bet you make generates immediate, withdrawable value with zero strings attached.",
    seoH3_3: "Maximizing Your Duel Casino Bonus",
    seoP3_1: "To get the most from your Duel Casino bonus, consider focusing on games with higher house edges where your 50% rakeback provides the greatest value. Original games and slots typically offer excellent rakeback opportunities. Your bonus code remains active permanently on your account.",
    seoP3_2: "Strategic players often combine the rakeback bonus with zero-edge games available on the platform. When you are playing games with no house advantage and still earning rakeback, you are actually playing with a mathematical edge in your favor.",
    seoProTip: "Pro Tip:",
    seoProTip1: "The Duel Casino bonus code COM works with all 16+ supported cryptocurrencies. Whether you prefer Bitcoin, Ethereum, Solana, or stablecoins like USDT, your 50% rakeback applies equally across all payment methods.",
    seoTitle2: "Duel Casino Review 2026: The Future of Crypto Gambling",
    seoIntro2: "Duel Casino has rapidly emerged as one of the most innovative crypto gambling platforms available today. Combining cutting-edge blockchain technology with a user-first approach, Duel Casino offers an experience that traditional online casinos simply cannot match. From instant cryptocurrency withdrawals to complete anonymity, every aspect of the platform is designed for the modern player.",
    seoH3_4: "What Makes Duel Casino Different",
    seoP4_1: "At its core, Duel Casino was built on three fundamental principles: transparency, speed, and privacy. Every game on the platform uses provably fair technology, allowing players to cryptographically verify that outcomes are genuinely random and unmanipulated.",
    seoP4_2: "The platform's architecture leverages blockchain technology not just for payments, but for game verification. Each bet generates a cryptographic hash that players can independently verify, ensuring that neither the casino nor any third party can manipulate results.",
    seoH3_5: "No KYC: True Anonymous Gaming",
    seoP5_1: "One of the most appealing features of Duel Casino is its no-KYC policy. Unlike traditional casinos that require extensive identity verification, Duel Casino allows you to start playing within seconds. You do not need to upload documents, wait for approval, or share personal information.",
    seoP5_2: "This approach reflects the original ethos of cryptocurrency — financial freedom without intermediaries. Your gambling activity remains private, and you maintain full control over your funds at all times.",
    seoH3_6: "Instant Cryptocurrency Withdrawals",
    seoP6_1: "Traditional online casinos often make players wait days or even weeks for withdrawal processing. Duel Casino takes a radically different approach with instant withdrawals available 24 hours a day, 7 days a week.",
    seoP6_2: "This instant access to your funds represents a fundamental shift in how online casinos operate. The moment you decide to withdraw, the transaction is processed automatically. Most withdrawals confirm on the blockchain within minutes.",
    seoGettingStarted: "Getting Started:",
    seoGettingStartedText: "Ready to experience Duel Casino for yourself? Use our exclusive bonus code COM during registration to unlock 50% instant rakeback. With no KYC requirements and instant crypto deposits, you can be playing within minutes.",
    pageNotFound: "Page not found",
    returnHome: "Return to Home",
    organizationDesc: "Independent guide to Duel Casino bonus codes, reviews, and expert insights for crypto gaming.",
    home: "Home",
    glossary: "Glossary",
    skipToContent: "Skip to main content",
    language: "Language",
    exitPopupTitle: "Wait! Don't Miss Out",
    exitPopupDesc: "Claim your exclusive 50% rakeback bonus before you go. It only takes seconds!",
    exitPopupValue: "50% Rakeback Value",
    exitPopupDismiss: "No thanks, I'll pass",
    
    // Duel Originals
    duelOriginals: "Duel Originals",
    zeroHouseEdge: "Zero House Edge",
    originalsDesc: "Play exclusive Duel games with 0% house edge. True fair play where only skill and luck determine outcomes.",
    zeroEdge: "0% House Edge",
    houseEdge: "House Edge",
    originalsInfo: "All Duel Originals are provably fair with cryptographically verified outcomes",
    
    // Newsletter
    newsletterTitle: "Subscribe to Newsletter",
    newsletterDesc: "Exclusive Duel.com giveaways, news and promotions. Never spammy.",
    newsletterPlaceholder: "Enter your email",
    newsletterButton: "Subscribe",
    newsletterPrivacy: "We respect your privacy. Unsubscribe anytime.",
    newsletterSuccess: "Successfully subscribed!",
    newsletterSuccessTitle: "You're In!",
    newsletterSuccessDesc: "You'll receive exclusive Duel.com updates and promotions.",
    newsletterErrorEmpty: "Please enter your email address",
    newsletterErrorInvalidFormat: "Please enter a valid email (e.g. name@example.com)",
    newsletterErrorAlreadySubscribed: "This email is already subscribed to our newsletter",
    newsletterErrorServer: "Unable to process your request. Please try again later",
    newsletterErrorConnection: "Connection failed. Please check your internet and try again",
    newsletterErrorRateLimit: "Too many attempts. Please try again in an hour",
    
    // Features Bento Grid
    houseEdgeDesc: "Duel Originals run at true 0% house edge. No hidden margins — just provably fair games where skill and luck determine outcomes.",
    rakebackDesc: "Get 50% of the house edge back instantly on every bet. No wagering requirements, no caps — real value credited to your balance immediately.",
    applies: "Applies to",
    instantRakeback: "Instant Rakeback",
    onDuelOriginals: "On Duel Originals",
    onHouseEdge: "On House Edge",
    cryptosSupported: "Cryptos",
    btcEthSol: "BTC, ETH, SOL & more",
    withdrawalTime: "Withdrawals",
    noDelaysShort: "24/7, no waiting",
    kycRequired: "KYC",
    playAnonymouslyShort: "Play anonymously",
    provablyFairTitle: "Provably Fair",
    provablyFairDesc: "Every game uses cryptographic verification. Verify outcomes yourself — no trust required.",
};

export default en;
